import { S3Endpoint } from "../config";
import { getCurrentLanguage } from "./getLanguage";

export const getPartnerImageByLang = partnerId => {
  return S3Endpoint.partnerLogo
    .replace("{:partnerId}", partnerId)
    .replace("{:lang}", getCurrentLanguage());
};
